import script from "./Languages.vue?vue&type=script&setup=true&lang=js"
export * from "./Languages.vue?vue&type=script&setup=true&lang=js"

import "./Languages.vue?vue&type=style&index=0&id=bfdeecf8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bfdeecf8"]])

export default __exports__